const STORAGE_KEY = 'cz_active_tenant_id';

export function getActiveTenantIdFromSession(): string | null {
    try {
        return sessionStorage.getItem(STORAGE_KEY);
    } catch {
        return null;
    }
}

export function setActiveTenantIdInSession(tenantId: string | null): void {
    try {
        if (tenantId) sessionStorage.setItem(STORAGE_KEY, tenantId);
        else sessionStorage.removeItem(STORAGE_KEY);
    } catch {
        /* ignore */
    }
}
